import { render, staticRenderFns } from "./MyPayHistory.vue?vue&type=template&id=88bd5864&scoped=true"
import script from "./MyPayHistory.vue?vue&type=script&lang=js"
export * from "./MyPayHistory.vue?vue&type=script&lang=js"
import style0 from "./MyPayHistory.vue?vue&type=style&index=0&id=88bd5864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bd5864",
  null
  
)

export default component.exports